export const RECRUITER_NETWORK_BANNER_BUTTON_TEXT =
  'Go to SEEK Recruiter Network';
export const RECRUITER_NETWORK_BANNER_SUBTITLE =
  'A recruiter helps you avoid the hidden costs of leaving a role unfilled, like decreased productivity and lost revenue';
export const RECRUITER_NETWORK_BANNER_TITLE =
  'Reduce how much vacancies are costing your business';
export const URL_RECRUITER_NETWORK = '/recruiter-network';
